// extracted by mini-css-extract-plugin
export var inlineLink = "_41-0";
export var inlineLinkButton = "_41-1";